module.exports = __webpack_public_path__ + "static/media/safety-at-risk.2e186a30.png";